export class ThinningMeasurementSummary {

  days_since_last: number;
  mean_of_top_15_by_diameter: number;
  mean_of_all_by_diameter: number;
  std_dev_of_all_by_diameter_growth: number;
  mean_of_top_15_by_diameter_growth: number;
  half_mean_of_top_15_by_diameter_growth: number;
  mean_of_all_by_diameter_growth: number;
  count_of_over_50_pct_fastest: number;
  count_of_under_50_pct_fastest: number;
  mean_of_over_50_pct_fastest: number;
  count_of_measured_fruit: number;
  predicted_pct_setting: number;

  constructor(private fields: any) {
    // Quick and dirty extend/assign fields to this model
    for (let f in fields) {
      this[f] = fields[f];
    }
  }

}



// WEBPACK FOOTER //
// ./src/models/thinning-measurement-summary.ts